<template>
    <div class="u-mt-20" style="padding: 20px 12px;">
        <h4>Atividades</h4>
        <p class="pa-sub">Atividades enviadas pelo professor, suas respostas e a devolutiva.</p>

        <div v-if="loading" class="pa-loading"><img src="/public/img/loading-bar.gif" /></div>

        <template v-else>
            <el-alert v-if="erro" type="warning" :closable="false" show-icon :title="erro" />

            <div v-else-if="atividades.length === 0" class="pa-vazio">
                Nenhuma atividade disponível no momento.
            </div>

            <div v-else>
                <div v-for="a in atividades" :key="a.id" class="card-ativ">
                    <div class="card-ativ-topo">
                        <strong>{{ a.titulo }}</strong>
                        <el-tag size="mini" :type="corSituacao(a.situacao)">{{ rotuloSituacao(a.situacao) }}</el-tag>
                    </div>

                    <div v-if="a.descricao" class="pa-menor u-mt-5">{{ a.descricao }}</div>

                    <div class="pa-menor u-mt-5">
                        <span v-if="a.data_limite">Prazo: {{ formatarData(a.data_limite) }}</span>
                        <span v-else>Sem prazo definido</span>
                        <span v-if="a.pontuacao_maxima"> · Vale {{ a.pontuacao_maxima }} ponto(s)</span>
                    </div>

                    <!-- Minha resposta -->
                    <div v-if="a.minha_resposta" class="bloco-resposta">
                        <div class="bloco-titulo">Sua resposta — {{ formatarData(a.minha_resposta.data_envio) }}</div>
                        <div>{{ a.minha_resposta.comentario || '—' }}</div>
                        <div v-if="a.minha_resposta.tem_arquivo" class="pa-menor">Arquivo enviado.</div>
                    </div>

                    <!-- Devolutiva do professor: autoria, data e estado explícitos -->
                    <div v-if="a.devolutiva && (a.devolutiva.texto || a.devolutiva.pontuacao !== null)"
                         class="bloco-devolutiva">
                        <div class="bloco-titulo">Devolutiva do professor
                            <span v-if="a.devolutiva.em" class="pa-menor">— {{ formatarData(a.devolutiva.em) }}</span>
                        </div>
                        <div v-if="a.devolutiva.texto">{{ a.devolutiva.texto }}</div>
                        <div v-if="a.devolutiva.pontuacao !== null && a.devolutiva.pontuacao !== undefined"
                             class="pontuacao">
                            Pontuação: <strong>{{ a.devolutiva.pontuacao }}</strong>
                        </div>
                    </div>

                    <div class="u-text-right u-mt-10">
                        <el-button v-if="a.situacao !== 'avaliada'" size="mini" type="primary"
                                   @click="abrirResposta(a)">
                            {{ a.minha_resposta ? 'Editar resposta' : 'Responder' }}
                        </el-button>
                    </div>
                </div>
            </div>
        </template>

        <el-dialog title="Responder atividade" :visible.sync="dialogo" width="92%" top="6vh">
            <div v-if="atual">
                <div class="pa-menor u-mb-10">{{ atual.titulo }}</div>

                <el-form label-position="top" size="mini">
                    <el-form-item label="Seu comentário">
                        <el-input type="textarea" :rows="5" v-model="comentario"
                                  maxlength="2000" show-word-limit
                                  placeholder="Escreva sua resposta para o professor" />
                    </el-form-item>
                </el-form>

                <div class="pa-menor">
                    O envio de arquivo usa o mesmo canal seguro dos materiais da turma.
                </div>
            </div>

            <span slot="footer">
                <el-button size="mini" @click="dialogo = false">Cancelar</el-button>
                <el-button size="mini" type="primary" :loading="enviando"
                           :disabled="!comentario || !comentario.trim()" @click="responder">
                    Enviar
                </el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
/**
 * BLOCO N — item 19.
 *
 * Consome `api/portal/atividades*`. O aluno envia APENAS `atividade_id` e `comentario`;
 * pontuação, situação e devolutiva são do professor e são ignoradas se vierem no payload.
 *
 * Nenhum caminho físico de arquivo é exibido: o backend devolve só `tem_arquivo`, e o
 * download continua passando pelo mecanismo autenticado da rodada 05A.
 */
export default {
    name: 'PortalAtividades',

    data: () => ({
        loading: true, enviando: false, erro: null,
        atividades: [], dialogo: false, atual: null, comentario: ''
    }),

    mounted () { this.carregar() },

    methods: {
        carregar () {
            this.loading = true
            this.erro = null

            this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/portal/atividades`,
                             {}, this.$store.getters.getHeaderAuth).then(r => {

                this.loading = false
                const d = r.data || {}
                if (d.erro) { this.erro = d.erro; return }

                this.atividades = d.atividades || []

            }).catch(() => {
                this.loading = false
                this.erro = 'Não foi possível carregar as atividades.'
            })
        },

        abrirResposta (a) {
            this.atual = a
            this.comentario = (a.minha_resposta && a.minha_resposta.comentario) ? a.minha_resposta.comentario : ''
            this.dialogo = true
        },

        responder () {
            if (!this.atual) return

            this.enviando = true

            this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/portal/atividades/responder`,
                             { atividade_id: this.atual.id, comentario: this.comentario },
                             this.$store.getters.getHeaderAuth).then(r => {

                this.enviando = false
                const d = r.data || {}

                if (d.erro) {
                    window.eventBus.$emit('alert', { msg: d.erro, type: 'warning' })
                    return
                }

                window.eventBus.$emit('alert', { msg: d.mensagem || 'Resposta enviada.', type: 'success' })
                this.dialogo = false
                this.carregar()

            }).catch(() => {
                this.enviando = false
                window.eventBus.$emit('alert', { msg: 'Não foi possível enviar a resposta.', type: 'warning' })
            })
        },

        formatarData (d) {
            if (!d) return '—'
            const p = String(d).substring(0, 10).split('-')
            return p.length === 3 ? `${p[2]}/${p[1]}/${p[0]}` : d
        },

        rotuloSituacao (s) {
            return { pendente: 'Pendente', entregue: 'Entregue', avaliada: 'Avaliada',
                     atrasada: 'Atrasada' }[s] || '—'
        },

        corSituacao (s) {
            return { pendente: 'info', entregue: 'primary', avaliada: 'success',
                     atrasada: 'danger' }[s] || 'info'
        }
    }
}
</script>

<style scoped>
.pa-loading { min-height: 300px; display: flex; justify-content: center; align-items: center; }
.pa-sub { color: #909399; }
.pa-menor { color: #909399; font-size: 12px; }
.pa-vazio { padding: 26px 12px; text-align: center; color: #909399; background: #fafafa; border-radius: 4px; }
.card-ativ { border: 1px solid #ebeef5; border-radius: 4px; padding: 12px; margin-bottom: 10px; }
.card-ativ-topo { display: flex; justify-content: space-between; align-items: center; flex-wrap: wrap; }
.bloco-resposta { background: #f5f7fa; border-radius: 4px; padding: 8px 10px; margin-top: 10px; font-size: 13px; }
.bloco-devolutiva { background: #f0f9eb; border-left: 3px solid #67c23a; border-radius: 4px;
                    padding: 8px 10px; margin-top: 8px; font-size: 13px; }
.bloco-titulo { font-weight: 600; margin-bottom: 4px; }
.pontuacao { margin-top: 4px; }
</style>
